module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "pn",
    attrs: {
      "id": "pt1"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("PART 1")])]), _vm._v(" "), _c('p', {
    staticClass: "pt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("High Summer")])]), _vm._v(" "), _c('p', {
    staticClass: "pep"
  }, [_vm._v("Now is the winter of our discontent")]), _vm._v(" "), _c('p', {
    staticClass: "pep-bot"
  }, [_vm._v("Made glorious summer by this sun of York.")]), _vm._v(" "), _c('p', {
    staticClass: "pepc"
  }, [_vm._v("—Shakespeare, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Richard III")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726f9926","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 72
// module chunks = 0